import {forwardRef, Ref} from 'react';

import {TestIdProps} from 'shared/web';

import {useDataGridFiltersModel} from '../context/useDataGridFiltersModel';
import {useResetFilterByUser} from '../hooks/useResetFilterByUser';
import {INoRowsOverlayParams} from '../types/AgGridTypes';
import {FeGridSettings} from '../types/Api';
import {DataGridProps} from '../types/DataGridProps';
import {DefaultEmptyStateRenderer} from './DefaultEmptyStateRenderer';

export interface EmptyStateRendererWrapperProps extends INoRowsOverlayParams, TestIdProps {
  gridProps: DataGridProps;
  settings: FeGridSettings;
}

export interface EmptyStateRendererWrapperProps extends INoRowsOverlayParams {
  gridProps: DataGridProps;
  settings: FeGridSettings;
}

export const EmptyStateRendererWrapper = forwardRef<HTMLDivElement, EmptyStateRendererWrapperProps>(
  EmptyStateRendererWrapperComponent
);
export function EmptyStateRendererWrapperComponent(
  props: EmptyStateRendererWrapperProps,
  ref: Ref<HTMLDivElement>
) {
  const {gridProps, api} = props;
  const {emptyState} = gridProps;

  const {isFilterActive} = useDataGridFiltersModel();
  const disableFilter = useResetFilterByUser(api);

  return (
    // There is style relying on this class
    // eslint-disable-next-line react/forbid-dom-props
    <div ref={ref} className="ag-custom-overlay-wrapper">
      <DefaultEmptyStateRenderer
        emptyStatus={emptyState}
        filterIsActive={isFilterActive}
        disableFilter={disableFilter}
        data-testid={props['data-testid']}
      />
    </div>
  );
}
